import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageSwitcher() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      data-testid="language-switcher"
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[#1A3557] hover:bg-[#234570] transition-colors text-sm font-medium border border-[#234570]"
    >
      <span className={`${language === 'fr' ? 'text-white font-bold' : 'text-slate-400'}`}>FR</span>
      <span className="text-slate-500">|</span>
      <span className={`${language === 'ro' ? 'text-white font-bold' : 'text-slate-400'}`}>RO</span>
    </button>
  );
}
